import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { apiClient } from "../services/api";

function GoogleOAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const role = searchParams.get("role");
    const error = searchParams.get("error");

    if (error) {
      console.error("Google OAuth 에러:", error);
      navigate("/login?error=google_auth_failed");
      return;
    }

    if (token && role) {
      // 토큰 저장
      apiClient.setToken(token);

      // 권한에 따라 리다이렉트
      if (role === "admin" || role === "teacher") {
        navigate("/student");
      } else {
        navigate("/viewer");
      }
    } else {
      navigate("/login?error=invalid_callback");
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <p>Google 로그인 처리 중...</p>
    </div>
  );
}

export default GoogleOAuthCallbackPage;
